/* PELYKO — une seule barre : on neutralise le header natif du thème
   et on redonne un menu mobile, la pilule masquant ses liens sous 1024px. */
(() => {
  if (window.__pelykoSoloNav) return;
  window.__pelykoSoloNav = true;

  const nav = document.querySelector('.pelyko-shell .pelyko-nav');
  if (!nav) return;

  document.documentElement.classList.add('pk-solo-nav');

  const inner = nav.querySelector('.pelyko-nav__inner');
  if (!inner || inner.querySelector('.pk-burger')) return;

  const burger = document.createElement('button');
  burger.type = 'button';
  burger.className = 'pk-burger';
  burger.setAttribute('aria-label', 'Ouvrir le menu');
  burger.setAttribute('aria-expanded', 'false');
  burger.innerHTML = '<span></span><span></span><span></span>';
  inner.insertBefore(burger, inner.firstChild);

  const menu = document.createElement('nav');
  menu.className = 'pk-mobile-menu';
  menu.setAttribute('aria-label', 'Menu');

  const links = [...nav.querySelectorAll('.pelyko-nav__links a')].map((a) => ({
    href: a.getAttribute('href'),
    label: a.textContent.trim()
  }));
  const extras = [
    { href: '/search', label: 'Rechercher' },
    { href: '/collections/all', label: 'Tous les produits' },
    { href: '/pages/guide-anti-poils-chien-chat', label: 'Guide anti-poils' },
    { href: '/blogs/conseils', label: 'Conseils' },
    { href: '/pages/suivi-de-commande', label: 'Suivi de commande' },
    { href: '/pages/contact', label: 'Contact' }
  ];

  const render = (items) => items
    .filter((item) => item.href)
    .map((item) => `<a href="${item.href}">${item.label}</a>`)
    .join('');

  menu.innerHTML = render(links) + '<hr>' + render(extras);
  nav.appendChild(menu);

  const setOpen = (open) => {
    menu.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
  };

  burger.addEventListener('click', (event) => {
    event.stopPropagation();
    setOpen(burger.getAttribute('aria-expanded') !== 'true');
  });
  menu.addEventListener('click', (event) => {
    if (event.target.closest('a')) setOpen(false);
  });
  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target) && !burger.contains(event.target)) setOpen(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth > 1024) setOpen(false);
  });
})();

/* PELYKO — jeu d'icônes maison. Remplace les pictos génériques de la barre
   par ceux dessinés pour la marque, sans toucher au script qui les a posés. */
(() => {
  if (window.__pelykoIcons) return;
  window.__pelykoIcons = true;

  const S = (inner, extra) =>
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" ' +
    'stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg>';

  const PAW_IN_BAG =
    '<g stroke="none" fill="currentColor">' +
    '<path d="M12 14.6c1.5 0 2.7 1.2 2.7 2.7 0 .6-.5 1-1 1h-3.4c-.6 0-1-.4-1-1 0-1.5 1.2-2.7 2.7-2.7z"/>' +
    '<ellipse cx="9.4" cy="13.9" rx=".85" ry="1.1"/><ellipse cx="11.4" cy="12.6" rx=".85" ry="1.15"/>' +
    '<ellipse cx="13.4" cy="12.6" rx=".85" ry="1.15"/><ellipse cx="15.3" cy="13.9" rx=".85" ry="1.1"/></g>';

  const PAW_ON_BOX =
    '<g stroke="none" fill="currentColor">' +
    '<path d="M7.9 14.9c.85 0 1.55.7 1.55 1.55 0 .35-.28.6-.6.6H6.9c-.33 0-.6-.25-.6-.6 0-.85.7-1.55 1.6-1.55z"/>' +
    '<ellipse cx="6.4" cy="14.5" rx=".5" ry=".62"/><ellipse cx="7.55" cy="13.8" rx=".5" ry=".64"/>' +
    '<ellipse cx="8.7" cy="13.8" rx=".5" ry=".64"/><ellipse cx="9.8" cy="14.5" rx=".5" ry=".62"/></g>';

  const ART = {
    search:   S('<path d="M6.9 5.1 5.3 1.9l3.4 1.5M14.5 5.1l1.6-3.2-3.4 1.5"/><circle cx="10.7" cy="10.7" r="6.3"/><path d="m15.4 15.4 5.1 5.1"/>'),
    account:  S('<circle cx="12" cy="8.1" r="3.5"/><path d="M5.4 20.3c.7-4.4 3.2-6.6 6.6-6.6s5.9 2.2 6.6 6.6"/>'),
    cart:     S('<path d="M4.6 8h14.8l-1.3 11.6a2.1 2.1 0 0 1-2.1 1.9H8a2.1 2.1 0 0 1-2.1-1.9z"/><path d="M9 8V6.3a3 3 0 0 1 6 0V8"/>' + PAW_IN_BAG),
    tracking: S('<path d="M3.8 7.5 12 3.1l8.2 4.4v9L12 20.9l-8.2-4.4z"/><path d="m3.8 7.5 8.2 4.4 8.2-4.4M12 11.9v9"/>' + PAW_ON_BOX)
  };

  const pick = (link) => {
    if (link.classList.contains('pelyko-icon-link--cart')) return ART.cart;
    if (link.classList.contains('pelyko-icon-link--tracking')) return ART.tracking;
    const href = link.getAttribute('href') || '';
    if (href.indexOf('/search') === 0) return ART.search;
    if (href.indexOf('/account') === 0) return ART.account;
    if (href.indexOf('/cart') === 0) return ART.cart;
    return null;
  };

  const apply = () => {
    document.querySelectorAll('.pelyko-shell .pelyko-icon-link').forEach((link) => {
      if (link.dataset.pkIcon === 'done') return;
      const art = pick(link);
      const svg = link.querySelector('svg');
      if (!art || !svg) return;
      const holder = document.createElement('span');
      holder.innerHTML = art;
      svg.replaceWith(holder.firstElementChild);
      link.dataset.pkIcon = 'done';
    });
  };

  apply();
  const observer = new MutationObserver(apply);
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 4000);
})();

/* PELYKO — le suivi est un accès service séparé, pas une icône collée au panier. */
(() => {
  if (window.__pelykoTrackingEntryLoaded) return;
  window.__pelykoTrackingEntryLoaded = true;

  const trackingIcon = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3.7 7.2 11 3.3l7.3 3.9v8.1L11 19.4l-7.3-4.1z"/><path d="m3.7 7.2 7.3 4 7.3-4M11 11.2v8.2"/><path d="M20.2 12.1c0 2.6-3.2 5.4-3.2 5.4s-3.2-2.8-3.2-5.4a3.2 3.2 0 1 1 6.4 0Z"/><circle cx="17" cy="12.1" r=".85"/></svg>';

  if (!document.getElementById('pelyko-tracking-entry-style')) {
    const style = document.createElement('style');
    style.id = 'pelyko-tracking-entry-style';
    style.textContent = `
      .pk-tracking-nav-link{display:inline-flex!important;align-items:center;gap:7px;padding:8px 12px!important;border:1px solid rgba(113,145,119,.34);border-radius:999px;background:rgba(113,145,119,.12);color:inherit!important;text-decoration:none!important;font-size:11px!important;font-weight:850!important;line-height:1!important;white-space:nowrap;transition:background .18s ease,border-color .18s ease,transform .18s ease}
      .pk-tracking-nav-link:hover{background:rgba(113,145,119,.22);border-color:rgba(113,145,119,.55);transform:translateY(-1px)}
      .pk-tracking-nav-link svg{width:18px!important;height:18px!important;flex:0 0 auto;fill:none;stroke:currentColor}
      @media(max-width:1024px){.pk-tracking-nav-link{display:none!important}}
      @media(prefers-reduced-motion:reduce){.pk-tracking-nav-link{transition:none}}
    `;
    document.head.appendChild(style);
  }

  const placeTracking = () => {
    document.querySelectorAll('.pelyko-shell .pelyko-icon-link--tracking, .pk-native-tracking-action').forEach((el) => el.remove());

    document.querySelectorAll('.pelyko-shell .pelyko-nav__links').forEach((links) => {
      if (links.querySelector('.pk-tracking-nav-link')) return;
      const tracking = document.createElement('a');
      tracking.className = 'pk-tracking-nav-link';
      tracking.href = '/pages/suivi-de-commande';
      tracking.setAttribute('aria-label', 'Suivre ma commande');
      tracking.setAttribute('title', 'Suivre ma commande');
      tracking.innerHTML = trackingIcon + '<span>Suivre ma commande</span>';
      links.appendChild(tracking);
    });
  };

  placeTracking();
  window.setTimeout(placeTracking, 200);
  window.setTimeout(placeTracking, 700);
  window.setTimeout(placeTracking, 1400);
  const observer = new MutationObserver(placeTracking);
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 3200);
})();
